export default __webpack_public_path__ + "static/media/IMG_5389.8a2ffb3b.PNG";